export default __webpack_public_path__ + "static/media/ubuntu.cc22841d.svg";